import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faPlus, faMinus} from '@fortawesome/fontawesome-free-solid/';
import {JR_THEME} from '../../reducers/topic-project';

import styles from './blocks-buttons.css';

const BlocksButtonsComponent = function (props) {
    const {
        isShowLessActive,
        isShowMoreActive,
        handleOnShowLessClicked,
        handleOnShowMoreClicked,
        theme
    } = props;
    return (
        <Box className={classNames(styles.blocksButtonsContainer, styles.blocks)}>
            <Button
                className={classNames(styles.blocksButton, styles.blocks,
                    [isShowLessActive ? styles.clickable : styles.notclickable],
                    {[styles.blocksButtonJr]: (theme === JR_THEME)})}
                disabled={!isShowLessActive}
                title={'Show Less'}
                onClick={handleOnShowLessClicked}
            >
                <FontAwesomeIcon
                    className={styles.icon}
                    draggable={false}
                    icon={faMinus}
                    title={'Show Less'}
                />
                <span>Show Less</span>
            </Button>
            <Button
                className={classNames(styles.blocksButton, styles.blocks,
                    [isShowMoreActive ? styles.clickable : styles.notclickable],
                    {[styles.blocksButtonJr]: (theme === JR_THEME)})}
                disabled={!isShowMoreActive}
                title={'Show More'}
                onClick={handleOnShowMoreClicked}
            >
                <FontAwesomeIcon
                    className={styles.icon}
                    draggable={false}
                    icon={faPlus}
                    title={'Show More'}
                />
                <span>Show More</span>
            </Button>
        </Box>
    );
};

BlocksButtonsComponent.propTypes = {
    handleOnShowLessClicked: PropTypes.func,
    handleOnShowMoreClicked: PropTypes.func,
    isShowLessActive: PropTypes.bool,
    isShowMoreActive: PropTypes.bool,
    theme: PropTypes.number
};

export default BlocksButtonsComponent;
